module.exports = __webpack_public_path__ + "img/img_1.799e2458.png";